export const initialState = {
  categories: [],
  category: {},
  categoryTreeData: [],
  loading: false
};
